import React from 'react';
import { CardViewContentProps } from './types';
import { Box } from '@mui/material';
import LibraryCategoryCard from '../../../../common/library-category-card/LibraryCategoryCard';
import ApartmentOutlinedIcon from '../../../../../assets/svg/apartment.svg?react';
import BadgeOutlinedIcon from '../../../../../assets/svg/badge-light.svg?react';
import SupportAgentOutlinedIcon from '../../../../../assets/svg/support-agent.svg?react';
import BusinessCenterIcon from '../../../../../assets/svg/business-center-v2.svg?react';
import { useTranslation } from 'react-i18next';
import DocumentListVault from '../document-list-vault/DocumentListVault';
import { useDocumentsMetaData } from '../../hooks/useDocumentsMetaData';

export const CardViewContent = ({
  activeTab,
  changeTabFunction,
  documents,
}: CardViewContentProps) => {
  const { t } = useTranslation();
  const { uploadedDocumentsMetaData } = useDocumentsMetaData(activeTab);
  const filterDataByCategory = (category: string) =>
    uploadedDocumentsMetaData.find((el) => el.category === category);
  if (activeTab === 'All') {
    return (
      <>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            gap: '24px',
            backgroundColor: 'transparent',
            flexWrap: 'wrap',
          }}
        >
          <LibraryCategoryCard
            title={t('Business')}
            description={
              (filterDataByCategory('business')?.count
                ? filterDataByCategory('business')?.count
                : 0) + (filterDataByCategory('business')?.count === 1 ? ' document' : ' documents')
            }
            onClick={() => changeTabFunction('Business')}
            icon={<ApartmentOutlinedIcon />}
            hasNewLabel={filterDataByCategory('business')?.isNew}
          />
          <LibraryCategoryCard
            title={t('Employment')}
            description={
              (filterDataByCategory('employment')?.count
                ? filterDataByCategory('employment')?.count
                : 0) +
              (filterDataByCategory('employment')?.count === 1 ? ' document' : ' documents')
            }
            onClick={() => changeTabFunction('Employment')}
            icon={<BadgeOutlinedIcon />}
            hasNewLabel={filterDataByCategory('employment')?.isNew}
          />
          <LibraryCategoryCard
            title={t('Customers')}
            description={
              (filterDataByCategory('customers')?.count
                ? filterDataByCategory('customers')?.count
                : 0) + (filterDataByCategory('customers')?.count === 1 ? ' document' : ' documents')
            }
            onClick={() => changeTabFunction('Customers')}
            icon={<SupportAgentOutlinedIcon />}
            hasNewLabel={filterDataByCategory('customers')?.isNew}
          />
          <LibraryCategoryCard
            title={t('Suppliers')}
            description={
              (filterDataByCategory('suppliers')?.count
                ? filterDataByCategory('suppliers')?.count
                : 0) + (filterDataByCategory('suppliers')?.count === 1 ? ' document' : ' documents')
            }
            onClick={() => changeTabFunction('Suppliers')}
            icon={<BusinessCenterIcon />}
            hasNewLabel={filterDataByCategory('suppliers')?.isNew}
          />
        </Box>
      </>
    );
  } else {
    /*if (!workflow) {
            if (activeTab === 'Business') {
              return <BusinessCategoryContent templates={templates} setWorkflow={setWorkflow} />;
            } else if (activeTab === 'Employment') {
              return <EmploymentCategoryContent templates={templates} setWorkflow={setWorkflow} />;
            } else if (activeTab === 'Customers') {
              return <CustomersCategoryContent templates={templates} setWorkflow={setWorkflow} />;
            } else if (activeTab === 'Suppliers') {
              return <SuppliersCategoryContent templates={templates} setWorkflow={setWorkflow} />;
            }
          }*/
    return (
      <>
        {/*<Box className={styles.breadcrumbs}>
          <Typography
            variant='h3'
            component='h3'
            className={styles.documentViewText}
            onClick={() => setWorkflow(null)}
          >
            {t('headers.workflows')}
          </Typography>
          <Typography variant='body2' className={styles.separator}>
            ›
          </Typography>
          <Typography variant='body2' className={styles.documentViewText}>
            {workflow}
          </Typography>
        </Box>*/}
        <DocumentListVault documents={documents} />
      </>
    );
  }
};
